/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1Fincen314EntryEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_FINCEN314_ENTRY_EVENT_ENTITY_NAME = 'ixf.watchlist.v1.Fincen314EntryEvent';
export const ixfWatchlistV1Fincen314EntryEventEntity = new schema.Entity<IxfWatchlistV1Fincen314EntryEvent>(IXF_WATCHLIST_V1_FINCEN314_ENTRY_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfWatchlistV1Fincen314EntryEvent) => `${entity.metadata?.eventId}` });

